import AOS from 'aos';

import './utils/vh.utils.js';
import './utils/animate-on-view.utils';

import './components/meta/select.component.js';

import './components/marquee/_index.js';
import './components/swiper/_index.js';
import './components/cards/_index.js';
import './components/sections/_index.js';
import './components/animations/_index.js';
import './components/accordions/_index.js';

import './components/validation.component.js';

import './components/uploadFile.component.js';
import './components/header.component.js';
import './components/inputs.component.js';
import './components/animations.component.js';
import './components/player.component.js';
import './components/search-sec.component.js';

import './components/connect.component.js';

import './components/our-mission.component.js';
import './components/join-us.component.js';

import './components/map.component.js';

import './libs/countUp.lib.js';
import './libs/smoothScrollbar.lib.js';

function applyVhOffset() {
  const vh = window.innerHeight;

  document.querySelectorAll('[data-aos-vh]').forEach(el => {
    const value = Number(el.dataset.aosVh); // 50
    const offsetPx = vh * (value / 100);

    el.setAttribute('data-aos-offset', offsetPx);

    console.log(el, offsetPx)
  });
}

applyVhOffset();

AOS.init({
  offset: 50,
  delay: 10,
  duration: 600,
  easing: 'ease-in-out',
  once: true,
});

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if(isSafari) document.body.classList.add('is-safari');

window.addEventListener('load', applyVhOffset);
